<template>
	<div :id="id" class="c-search-section-pages snap-m-320">
		<div
			:class="[
				'grid gap-layout-gutter',
				'grid-cols-1 >=768:grid-cols-2 >=1024:grid-cols-3',
			]"
		>
			<ContentCard
				v-for="(item, index) in items"
				:key="`item-${index}`"
				:title="item.name"
				:teaser="item.teaser"
				:link="{ url: item.url }"
				:has-external-outbound-redirect="
					item.hasExternalOutboundRedirect
				"
				:external-outbound-redirect="item.externalOutboundRedirect"
			>
				<template #before>
					<span
						class="font-darker-grotesque font-semibold"
						v-html="computedOverlines[index]"
					></span>
				</template>
			</ContentCard>
		</div>
	</div>
</template>

<script>
import ContentCard from '~/components/shared/ContentCard';

export default {
	name: 'SearchSectionPages',
	components: { ContentCard },

	props: {
		id: {
			type: String,
			required: true,
		},

		items: {
			type: Array,
			default: () => [],
		},
	},

	computed: {
		computedOverlines() {
			return this.items.map((item) => {
				return item.breadcrumb?.[item.breadcrumb.length - 2].name || '';
			});
		},
	},
};
</script>
